jQuery(function($){
  $('body.ie input').placeholder();
});
